"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDurationLimitOptions = exports.DURATION_LIMIT_OPTIONS = void 0;
var react_1 = require("react");
var public_api_1 = require("@l2p/public-api");
var next_intl_1 = require("next-intl");
exports.DURATION_LIMIT_OPTIONS = [
    public_api_1.GameDurationType.Day,
    public_api_1.GameDurationType.Week,
    public_api_1.GameDurationType.Month,
];
var useDurationLimitOptions = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        return exports.DURATION_LIMIT_OPTIONS.reduce(function (acc, option, idx) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[idx] = t(option), _a)));
        }, {});
    }, [t]);
};
exports.useDurationLimitOptions = useDurationLimitOptions;
